import React, { ReactElement } from "react"
import { ComputedProps } from "./__config/shape"
import ComputedPanels from "../ComputedPanels"
import { addDollarSign, formatNumber } from "../../util/money/formatting"

/**
 * Component used to display the Available to Spend value
 *
 * @export
 * @param {ComputedProps} {
 * 	value,
 * }
 * @returns {ReactElement}
 */
export default React.memo(function AvailableToSpend({
	value,
}: ComputedProps): ReactElement {
	return (
		<ComputedPanels
			title="Dostupno za potrošnju (bez PDV-a i poreza)"
			description=""
			value={addDollarSign(formatNumber(value))}
		/>
	)
})
